import { type ReactElement } from 'react'
import { type WithUserId } from '@terros/common'
import { TButton } from 'app/components/buttons'
import { UserInfo } from 'app/components/entityInfo'

export type UserButtonProps = Partial<WithUserId> & {
  label: string
  onClick: VoidFunction
}

export const UserButton = ({ userId, label, onClick }: UserButtonProps): ReactElement => {
  return (
    <TButton
      icon={userId ? undefined : 'person'}
      justify='start'
      size='medium'
      variant={userId ? 'secondary' : 'gray'}
      onClick={onClick}
    >
      {userId ? <UserInfo linked={false} userId={userId} /> : label}
    </TButton>
  )
}
